"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTSL001_Detail = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../common");
const FileDown_1 = require("../../../common/option/FileDown");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const layout_1 = require("../../base/layout");
const DeletePopUpLayout_1 = require("../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../base/popup");
const action_1 = require("../../menu/action");
const constant_1 = require("./constant");
const DSTSL001_Regist_Child_1 = require("./DSTSL001_Regist_Child");
const commonStyles = (0, styled_components_1.css) `
	width: 100%;
	flex: 1;
	${props => props.$isMobile && `height: 100%;`}
	.attach-files {
		width: 100%;
	}

	.quill_wrap {
		height: 100%;
	}

	.edit-delete {
		display: flex;
		flex-direction: row;
		gap: 8px;
	}

	.teacher-info {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		padding: 0px 0px 8px 0px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		letter-spacing: var(--b4-letter-spacing, -0.02em);
		font-weight: var(--b4-font-weight, 400);
		color: var(--color-grey, #666666);

		.name {
			display: flex;
			flex-direction: row;
			gap: 12px;
		}
	}

	.btn-container {
		padding-top: 0px;
		position: absolute;
		right: 28px;
	}

	.underline {
		text-decoration: underline;
	}

	.green {
		color: var(--tur-d, #479da6);
	}

	.pur-d {
		color: var(--pur-d, #8268d9);
	}

	.pink {
		color: var(--color-accent, #e7424c);
	}

	.open-contents {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		color: var(--natural-color-n-0, #2f2f2f);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		height: 100%;

		.img_wrap {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.img {
				border-radius: 4px;
				flex-shrink: 0;
				width: 100px;
				height: 100px;
				position: relative;
				object-fit: cover;
				background: #000;
			}
		}
	}

	.content-main {
		width: 100%;
		border-style: dashed;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 1px 0px;
		flex: 1;

		.fext-field {
			border: none;
		}
	}

	svg {
		min-width: 16px;
	}

	.btn-container {
		padding: 0;
	}

	.content-info-section {
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 24px;

		.content-infos {
			gap: 8px;
			display: flex;
			flex-direction: column;
			width: 100%;
			overflow: hidden;
		}

		.content-info {
			gap: 12px;
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		.content-info-title {
			font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
			font-size: 16px;
			line-height: 32px;
			white-space: nowrap;
			font-weight: 700;
		}

		.content-info-filename {
			align-self: center;
			font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
			font-size: 16px;
			line-height: 32px;
		}

		.content_empty_file {
			background: var(--color-white, #ffffff);
			color: var(--color-grey-l, #83868a);
			text-align: left;
			font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b5-font-size, 12px);
			line-height: var(--b5-line-height, 22px);
			letter-spacing: var(--b5-letter-spacing, -0.02em);
			font-weight: var(--b5-font-weight, 400);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			width: 100%;
			padding-left: 10px;
		}

		.content-info-value {
			display: inline-flex;
			align-items: center;
			font-size: 16px;
			line-height: 14px;
			font-weight: 400;
			flex-wrap: wrap;
			gap: 10px;
		}

		.no-file-wrap {
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			overflow: auto;
			width: 100%;
		}
	}

	.divider {
		width: 1px;
		height: 14px;
		background-color: var(--color-grey-c, #e6e8ed);
	}
`;
const mobileStyles = (0, styled_components_1.css) `
	.open-contents {
		padding: 16px 20px;

		.img_wrap {
			gap: 8px;
			display: flex;
			flex-wrap: wrap;
			width: 100%;
		}
		.img_pair {
			display: flex;
			flex-direction: column;
			gap: 8px;
		}
	}

	.teacher-info {
		border-width: 0px 0px 0.5px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
				font-size: 12px;
			}
		}
	}

	.content-info-section {
		.content-info {
			height: auto;
		}

		.content-infos {
			gap: 4px;
		}

		.content-info-title {
			font-size: 14px;
		}

		.content-info-value {
			font-size: 14px;
			min-width: 93px;
		}

		.content-info-filename {
			align-self: start;
			font-size: 14px;
			flex-direction: row;
		}
	}

	.content-main {
		padding: 16px 0;
	}

	.no-mw {
		.overText {
			font-size: 12px;
			min-width: 0px;
		}
	}

	.disable-text {
		p {
			font-size: 14px;
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	padding: 20px;
	.open-contents {
		padding: 0px;
		.img_wrap {
			gap: 12px;
		}
	}

	.content-info-section {
		.content-info {
			height: auto;
		}

		.content-info-value {
			min-width: 93px;
		}

		.content-info-filename {
			align-self: start;
			line-height: 25px;
		}
	}

	.content-main {
		padding: 16px 0;
	}

	.file-container {
		.file-item-wrap {
			padding: 0px;
		}
	}

	.teacher-info {
		border-width: 0px 0px 1px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	.open-contents {
		padding: 24px 0px;
		height: calc(100% - 52px);
	}

	.content-main {
		padding: 20px 0;
	}

	.teacher-info {
		border-width: 0px 0px 1px 0px;
		.active-bar {
			.button p {
				min-width: fit-content;
			}
		}
	}
`;
const DSTL001DetailStyled = styled_components_1.default.div `
	${commonStyles}

	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const DSTSL001_Detail = ({ isResource = false, isTeacher, selectedId, }) => {
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [testData, setTestData] = react_1.default.useState(null);
    const deletePostMutation = (0, react_query_1.useMutation)(server_1.postDeletePosts);
    //조회수 증가
    const { data, refetch } = (0, server_1.useNoticeList)({
        id: selectedId,
        with_content: true,
    });
    (0, react_1.useEffect)(() => {
        selectedId && refetch();
    }, [selectedId]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items } = data;
            if (items && items.length > 0) {
                setTestData(items[0]);
            }
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (testData && !isDesktop) {
            dispatch((0, action_1.changeMobileMenuName)(testData.title));
        }
    }, [testData, isDesktop, isTablet, isMobile]);
    // (리스트 갱신
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REFRESH_POSTS_DETAIL_LIST', refetchList);
        return () => {
            APP.eventManager.unsubscribe('REFRESH_POSTS_DETAIL_LIST', refetchList);
        };
    }, []);
    //게시글 삭제
    const handleDelete = () => {
        const onDelete = async () => {
            const id = testData.id;
            try {
                await deletePostMutation.mutateAsync(id);
                handlerPreviousPage();
                APP.eventManager.publish(constant_1.REFRESH_POSTS_LIST);
            }
            catch (error) {
                console.error('Failed to post deletePost:', error);
                alert(error);
            }
        };
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t('assignment.delteInto', { count: 1 }),
                onDelete,
            },
            width: 639,
            title: t(`supportRoom.${isResource ? 'resource' : 'notice'}Delete`),
            isFit: true,
        });
    };
    const handleEdit = () => {
        dispatch((0, action_1.updateMenu)(isResource ? 'learningSupportRoom' : 'notice', {
            menu: isResource ? 'resource' : 'notice',
            detail: 'modify',
        }, testData.id, {
            item: testData,
            isModify: true,
            isTeacher,
            isResource,
            isPopup: true,
        }));
    };
    const handlerPreviousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
    };
    /**
     *  상단 타이틀
     */
    const renderTitleInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo
    // title={t(`supportRoom.${isResource ? 'resource' : 'notice'}`)}
    , { 
        // title={t(`supportRoom.${isResource ? 'resource' : 'notice'}`)}
        title: testData?.title, previousPage: handlerPreviousPage })), [isResource, testData]);
    const creationDate = String(testData?.creation_time).split('T')[0];
    return (react_1.default.createElement(DSTL001DetailStyled, { className: "dstl001_detail wrapper-padding", "$isMobile": isMobile, "$isTablet": isTablet, "$isDetail": selectedId ? true : false },
        isDesktop && renderTitleInfo,
        react_1.default.createElement("div", { className: "open-contents" },
            react_1.default.createElement("div", { className: "content-info-section" },
                react_1.default.createElement("div", { className: "content-infos" },
                    react_1.default.createElement("div", { className: "content-info" },
                        react_1.default.createElement("div", { className: "content-info-title" }, t('table.creation_time')),
                        react_1.default.createElement("div", { className: "divider" }),
                        react_1.default.createElement("div", { className: "content-info-value" }, creationDate)),
                    react_1.default.createElement("div", { className: "content-info" },
                        react_1.default.createElement("div", { className: "content-info-title" }, t('table.views')),
                        react_1.default.createElement("div", { className: "divider" }),
                        react_1.default.createElement("div", { className: "content-info-value" }, testData?.views)),
                    react_1.default.createElement("div", { className: "content-info" },
                        react_1.default.createElement("div", { className: "content-info-title" }, t('table.attachFile')),
                        react_1.default.createElement("div", { className: "divider" }),
                        react_1.default.createElement("div", { className: "content-info-value" },
                            react_1.default.createElement(FileDown_1.FileDown, { files: testData?.files, isOpen: true }))))),
            react_1.default.createElement("div", { className: "content-main" },
                react_1.default.createElement(DSTSL001_Regist_Child_1.RegistContent, { isDisbaled: true, hideTitle: true, contentName: t('supportRoom.content'), defaultValue: testData?.content, isTeacher: isTeacher, isLearningSupport: true })),
            react_1.default.createElement("div", { className: "list-button-section", style: {
                    ...(isMobile ? { height: 'unset', paddingBottom: '24px' } : {}),
                } },
                react_1.default.createElement(common_1.Button, { className: `button btn_white xmd`, text: '목록', onClick: handlerPreviousPage }),
                isTeacher && (react_1.default.createElement("div", { className: "edit-delete" },
                    react_1.default.createElement(common_1.Button, { className: `button btn_line_pink xmd`, text: 'common.delete', onClick: handleDelete }),
                    react_1.default.createElement(common_1.Button, { className: `button btn_white xmd`, text: 'common.modify', onClick: handleEdit })))))));
};
exports.DSTSL001_Detail = DSTSL001_Detail;
